/**
 * Glamood App Bridge
 * Handles communication between Shopify theme and the Glamood mobile app
 */

class GlamoodAppBridge extends HTMLElement {
  
  static DEBUG = false;
  static FORCE_REDIRECT = false;

  constructor() {
    super();
    this.isAppSession = this.detectAppSession() || GlamoodAppBridge.DEBUG;
    this.currentLanguage = document.documentElement.lang || 'it';
  }

  connectedCallback() {
    /*
    if(this.detectOldAppSession() && GlamoodAppBridge.FORCE_REDIRECT){
      if(window.location.pathname.includes("/pages/download-app")){
        console.log('Already on download page, not redirecting');
      }else{
        window.location.href = '/pages/download-app';
        console.log("Why...");
        return;
      }
    }
      */
    this.mainSectionUrl = document.getElementById('main-header-container')?.getAttribute('data-url').replace('/', '');
    if (this.mainSectionUrl.startsWith('it') || this.mainSectionUrl.startsWith('de') || this.mainSectionUrl.startsWith('ko')) {
      if(this.mainSectionUrl.length > 3){
        this.mainSectionUrl = this.mainSectionUrl.substring(3);
      }else{
        this.mainSectionUrl = '';
      }
    }
    this.init();
    console.log('GlamoodAppBridge initialized. App session:', this.isAppSession);
  }

  /**
   * Detect if session is from the app by checking user agent
   */
  detectAppSession() {
    return navigator.userAgent.toLowerCase().includes('glamoodapp2');
  }
  detectOldAppSession(){
    return navigator.userAgent.toLowerCase().includes('glamoodapp') && !this.detectAppSession();
  }
  
  
  adoptedCallback() {
    /*
    if(this.detectOldAppSession() && GlamoodAppBridge.FORCE_REDIRECT){
      if(window.location.pathname.includes("/pages/download-app")){
        console.log('Already on download page, not redirecting');
      }else{
        window.location.href = '/pages/download-app';
        console.log("Why...");
        return;
      }
    }
      */
    this.mainSectionUrl = document.getElementById('main-header-container')?.getAttribute('data-url').replace('/', '');
    if (this.mainSectionUrl.startsWith('it') || this.mainSectionUrl.startsWith('de') || this.mainSectionUrl.startsWith('ko')) {
      if(this.mainSectionUrl.length > 3){
        this.mainSectionUrl = this.mainSectionUrl.substring(3);
      }else{
        this.mainSectionUrl = '';
      }
    }
    this.init();
  }
  /**
   * Initialize the app bridge
   */
  init() {
    if(this.isAppSession) {
        /*
        this.please = document.createElement('div');
        this.please.style.width = '100%';
        this.please.style.height = '100px';
        this.please.style.position = 'fixed';
        this.please.style.bottom = '0';
        this.please.style.left = '0';
        this.please.style.zIndex = '9999';
        this.please.style.backgroundColor = 'red';
        document.querySelector('body').appendChild(this.please);
        */
      this.initializeSearchToogle();
      this.hideElementsForApp();
      this.initializeEventListeners();
      this.sendInitialData();
      this.checkLanguageOnPageLoad();
      this.setMainSection();
      //this.please.innerText = this.please.innerText + '\n' + window.location.href;
    }
  }

  initializeSearchToogle() {
    window.toggleCatalogSuggest = () => {
      const searchDrawer = document.querySelector('#search-drawer-offcanvas');
      if (searchDrawer) {
        searchDrawer.toggle();
      } else {
        console.warn('Search drawer not found');
      }
    }
  }

  /**
   * Check language on page load and update app if different from sessionStorage
   */
  checkLanguageOnPageLoad() {
    if (!this.isAppSession) return;
    let currentLanguage = document.documentElement.lang || document.body.getAttribute('data-language')  || 'it';
    const storedLanguage = sessionStorage.getItem('locale') || null;
    if (!storedLanguage) {
      sessionStorage.setItem('locale', currentLanguage);
      console.log('No stored language, setting to current:', currentLanguage);
      this.changeLanguage(currentLanguage);
      //this.please.innerText = 'Language not changed: ' + currentLanguage;
      return;
    }
    // If language is different from stored value, update app and storage
    if (currentLanguage !== storedLanguage) {
      sessionStorage.setItem('locale', currentLanguage);
      this.changeLanguage(currentLanguage);
      //this.please.innerText = this.please.innerText +  '\nLanguage changed to: ' + currentLanguage + " iso-code: " + document.body.getAttribute('data-language');
    }else{
      console.log('Stored language matches current language:', currentLanguage);
    }
  }

  /**
   * Hide header and footer elements when in app session
   */
  hideElementsForApp() {
    // Check if body has menupage-template class
    const isMenuPage = document.body.classList.contains('menu-page-template');
    
    // Hide header elements (desktop and mobile)
    // On menu pages, keep mobile-header-menu visible
    const headerSelector = isMenuPage ? 
      '.desktop-header, .mobile-header-row' : 
      'desktop-header, .mobile-header, .mobile-header-row, #mobile-header-menu';
    
    const headerElements = document.querySelectorAll(headerSelector);
    headerElements.forEach(element => {
      element.style.display = 'none';
    });

    // Hide footer elements
    const footerElements = document.querySelectorAll('footer, .footer-section');
    footerElements.forEach(element => {
      element.style.display = 'none';
    });

    // Hide navigation menus and offcanvas elements
    if (!isMenuPage) {
    const navigationElements = document.querySelectorAll('.nav:not(.mobile-account-menu), .navigation, [id*="mobile-header"], [class*="mobile-header"], mc-offcanvas[id*="mobile"]');
    navigationElements.forEach(element => {
      element.style.display = 'none';
    }); 

    // Add app session class to body for styling
    document.body.classList.add('glamood-app-session');
    }
  }

  /**
   * Send command to the app
   * @param {string} instruction - The instruction name
   * @param {string|array} parameters - Parameters for the instruction
   */
  sendToApp(instruction, parameters = '') {
    let paramString = '';
    
    if (Array.isArray(parameters)) {
      paramString = parameters.join('|');
    } else if (parameters) {
      paramString = parameters.toString();
    }

    const command = paramString ? `fromjavascript:${instruction}:${paramString}` : `fromjavascript:${instruction}`;

    console.log('Sending to app:', command);
    window.location.href = command;
  }

  /**
   * Send multiple commands at once
   * @param {array} commands - Array of {instruction, parameters} objects
   */
  sendMultipleToApp(commands) {
    const commandStrings = commands.map(cmd => {
      let paramString = '';
      if (Array.isArray(cmd.parameters)) {
        paramString = cmd.parameters.join('|');
      } else if (cmd.parameters !== null && cmd.parameters !== undefined && cmd.parameters !== '') {
        paramString = cmd.parameters.toString();
      }
      return paramString !== '' ? 
        `${cmd.instruction}:${paramString}` : 
        cmd.instruction;
    });

    const multiCommand = `fromjavascript:${commandStrings.join('§')}`;
    console.log('Sending multiple to app:', multiCommand);
    window.location.href = multiCommand;
  }

  /**
   * Update wishlist badge count
   * @param {number} count - Number of items in wishlist
   */
  updateWishlistBadge(count = 0) {
    if (this.isAppSession) {
      this.sendToApp('refreshFavourites', count);
    }
  }

  /**
   * Update cart badge count
   * @param {number} count - Number of items in cart
   */
  updateCartBadge(count = 0) {
    if (this.isAppSession) {
      this.sendToApp('refreshCart', count);
    }
  }

 

  /**
   * Communicate language change
   * @param {string} languageCode - Two-character language code (e.g., 'en', 'it')
   */
  changeLanguage(languageCode) {
    if (this.isAppSession) {
      this.sendToApp('changeLanguage', languageCode);
    }
  }

  /**
   * Signal which tab should be active
   * @param {number} tabIndex - Tab index (0=Home, 1=Wishlist, 2=Account, 3=Cart, 4=Menu)
   */
  changeTab(tabIndex) {
    if (this.isAppSession) {
      this.sendToApp('changeTab', tabIndex);
    }
  }

  /**
   * Indicate main section change
   * @param {string} section - Section identifier (e.g., 'women.htm', 'men.htm')
   */
  changeMainSection(section) {
    if (this.isAppSession) {
      this.sendToApp('changeMainSection', section);
    }
  }
  setMainSection() {
    if (this.isAppSession) {
      //this.please.innerText = 'Setting main section...' + (this.mainSectionUrl || 'no section url found');
      const sectionurl = this.mainSectionUrl ? this.mainSectionUrl : '';
      
      if (sectionurl) {
        this.sendToApp('currentMainSection', sectionurl);
      }
    }
  }
  /**
   * Force external link to open in native browser
   * @param {string} url - Full URL including https, query string, and hash
   */
  openExternalLink(url) {
    if (this.isAppSession) {
      this.sendToApp('openExternalLink', url);
    }
  }

  /**
   * Get current cart count from DOM
   */
  getCurrentCartCount() {
    const cartCountElement = document.querySelector('.cart-count');
    if (cartCountElement) {
      const count = parseInt(cartCountElement.textContent);
      return isNaN(count) ? 0 : count;
    }
    
    // Fallback: try to get from window object if available
    if (window.theme && window.theme.cart) {
      const count = parseInt(window.theme.cart.item_count);
      return isNaN(count) ? 0 : count;
    }
    
    return 0;
  }

  /**
   * Get current wishlist count from Wishlist Hero SDK
   */
  getCurrentWishlistCount() {
    // Check if Wishlist Hero SDK is available
    if (window.WishListHero_SDK && typeof window.WishListHero_SDK.GetWishListItemsCount === 'function') {
      try {
        const wishlistItems = window.WishListHero_SDK.GetWishListItemsCount();
        return wishlistItems || 0;
      } catch (error) {
        console.warn('Error getting wishlist count from WishListHero_SDK:', error);
      }
    }

    // Fallback: try to get from DOM element if SDK is not ready
    const wishlistCountElement = document.querySelector('.wishlist-count');
    if (wishlistCountElement) {
      return parseInt(wishlistCountElement.textContent) || 0;
    }
    
    return 0;
  }

  /**
   * Determine current tab based on page type
   */
  getCurrentTab() {
    const path = window.location.pathname.toLowerCase();
      // Home page or default
    if (path === '/' || path === '') {
      return 0; // Home
    }
    // Check for wishlist/favorites pages
    if (path.includes('/wishlist') || path.includes('/favorites') || path.includes('/favourite') ) {
      return 1; // Wishlist
    }
      // Check for account pages
    if (path.includes('/account') ) {
      return 2; // Account
    }
    // Check for cart pages
    if (path === '/cart' || path.includes('/cart')) {
      return 3; // Cart
    }
    // Check for menu/navigation pages
    if (path.includes('/menu') || path.includes('/menu-page') || path.includes('menuapp') ) {
      return 4; // Menu
    }
    // Product pages or other content pages default to Home tab
    return 0; // Default to Home
  }

  /**
   * Determine current main section based on active menu or product genre
   */
  getCurrentMainSection() {
    // Check for active menu item
    const activeMenuItem = document.querySelector('.nav-link.active');
    if (activeMenuItem) {
      const handle = activeMenuItem.id;
      if (handle === 'donna' || handle === 'women') return 'women.htm';
      if (handle === 'uomo' || handle === 'men') return 'men.htm';
      if (handle === 'bambino' || handle === 'children') return 'children.htm';
    }
    
    // Check for product genre
    const productGenre = document.querySelector('[data-product-genre]');
    if (productGenre) {
      const genre = productGenre.getAttribute('data-product-genre');
      if (genre === 'donna' || genre === 'women') return 'women.htm';
      if (genre === 'uomo' || genre === 'men') return 'men.htm';
      if (genre === 'bambino' || genre === 'children') return 'children.htm';
    }
    
    return 'women.htm'; // Default to women
  }

  /**
   * Send initial data to app on page load
   */
  sendInitialData() {
    if (!this.isAppSession) return;

    const commands = [
      { instruction: 'refreshCart', parameters: this.getCurrentCartCount() },
      { instruction: 'refreshFavourites', parameters: this.getCurrentWishlistCount() },
      { instruction: 'changeTab', parameters: this.getCurrentTab() },
      { instruction: 'changeMainSection', parameters: this.getCurrentMainSection() },
    ];
    this.sendMultipleToApp(commands);
  }

  /**
   * Handle Wishlist Hero SDK initialization
   */
  initializeWishlistHero() {
    if (!this.isAppSession) return;
    
    if (window.WishListHero_SDK && typeof window.WishListHero_SDK.GetWishListItems === 'function') {
      const count = this.getCurrentWishlistCount();
      this.updateWishlistBadge(count);
    }
  }
  /**
   * Initialize pathname change listener to update tab when navigation occurs
   */
  initializePathnameListener() {
    let currentPathname = window.location.pathname;
    
    // Create a function to check for pathname changes
    const checkPathnameChange = () => {
      const newPathname = window.location.pathname;
      if (newPathname !== currentPathname) {
        currentPathname = newPathname;
        const newTab = this.getCurrentTab();
        this.changeTab(newTab);
      }
    };

    // Listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', checkPathnameChange);

  }

  /**
   * Initialize event listeners for cart updates, menu changes, etc.
   */
  initializeEventListeners() {
    if (!this.isAppSession) return;
    
    // Listen for pathname changes to update current tab
    this.initializePathnameListener();
    
    // Look for both cart drawer and main cart page elements
    /*
    const cartMain = document.querySelectorAll('mc-cart');
    if (cartMain.length > 0) {
      cartMain.forEach(cart => {
        cart.addEventListener('cart:updated', (event) => {
          const count = event.detail?.item_count || this.getCurrentCartCount();
          // Ensure count is always a number, default to 0 if not
          const validCount = (typeof count === 'number' && !isNaN(count)) ? count : 0;
          this.updateCartBadge(validCount);
        });
      });
    }
      */

    document.addEventListener('app-localization-submit', (event) => {
      const language = event.detail?.language || this.currentLanguage;
      this.currentLanguage = language;
      this.changeLanguage(language);
    })

    // Listen for Wishlist Hero SDK ready event
    document.addEventListener('wishlist-hero-wishlist-sdk-ready', () => {
      const count = this.getCurrentWishlistCount();
      this.updateWishlistBadge(count);
    });

    // Listen for general wishlist updates (fallback)
    document.addEventListener("mc:wishlist:added", () => {
      const count =  this.getCurrentWishlistCount();
      this.updateWishlistBadge(count);
    });

    // Listen for wishlist item removal
    document.addEventListener("mc:wishlist:removed", () => {
      const count = this.getCurrentWishlistCount();
      this.updateWishlistBadge(count);
    });

    // Note: Additional Wishlist Hero events would need to be documented
    // Currently only 'wishlist-hero-wishlist-sdk-ready' is confirmed
    // If Wishlist Hero provides other events (like item added/removed), 
    // they should be added here based on official documentation


    // Listen for menu tab changes
    document.addEventListener('click', (event) => {
      const tabButton = event.target.closest('.nav-link[data-bs-toggle="tab"]');
      if (tabButton) {
        const handle = tabButton.id;
        let section = 'women.htm';
        if (handle === 'uomo' || handle === 'men') section = 'men.htm';
        if (handle === 'bambino' || handle === 'children') section = 'children.htm';
        
        this.changeMainSection(section);
      }
    });

    // Listen for external links
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (link && link.getAttribute('data-external') === 'true') {
        event.preventDefault();
        this.openExternalLink(link.href);
      }
    });

    // Check for Wishlist Hero SDK availability periodically if not immediately available
    if (!window.WishListHero_SDK) {
      const checkSDK = setInterval(() => {
        if (window.WishListHero_SDK) {
          clearInterval(checkSDK);
          const count = this.getCurrentWishlistCount();
          this.updateWishlistBadge(count);
        }
      }, 500);
      
      // Stop checking after 10 seconds
      setTimeout(() => clearInterval(checkSDK), 10000);
    }
  }
}

// Initialize the app bridge when DOM is loaded
/*
document.addEventListener('DOMContentLoaded', () => {
  window.glamoodAppBridge = new GlamoodAppBridge();
});
*/

if(!window.customElements.get('glamood-app-bridge')){
    window.customElements.define('glamood-app-bridge', GlamoodAppBridge);
}

class AppLocalizationSubmit extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback(){
      
      if(!this.detectAppSession()){
        return;
      } 
      
      this.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
        this.handleSubmit();
      });
    }
    handleSubmit = () => {
      this.language = this.closest('form').querySelector('#language-select').value;
      sessionStorage.setItem('locale', this.language);
      window.location.href = `fromjavascript:changeLanguage:${this.language}`;
    }
    detectAppSession = () => {
      return navigator.userAgent.toLowerCase().includes('glamoodapp2');
    }
}
if(!window.customElements.get('app-localization-submit')){
    window.customElements.define('app-localization-submit', AppLocalizationSubmit);
}